__turbopack_context__.v({
  "button": "zr6Faa_button",
  "buttonActive": "zr6Faa_buttonActive",
  "buttonProductPage": "zr6Faa_buttonProductPage",
  "content": "zr6Faa_content",
  "contentProductPage": "zr6Faa_contentProductPage",
  "icon": "zr6Faa_icon",
});
